import { RouterOutputs } from '@duke-hq/svc-api/admin';
import { proxy } from 'valtio';

class CourseEditorState {
  course: RouterOutputs['courses']['byId'] | null = null;
}

export const courseEditorState = proxy(new CourseEditorState());
